import { render, staticRenderFns } from "./tool-edit-info-base-info.vue?vue&type=template&id=3c3a3b3d&scoped=true&"
import script from "./tool-edit-info-base-info.vue?vue&type=script&lang=js&"
export * from "./tool-edit-info-base-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3a3b3d",
  null
  
)

export default component.exports